// extracted by mini-css-extract-plugin
export default {"root":"TopOperations_root__RPkgB","search":"TopOperations_search__a9g8G","option":"TopOperations_option__xsQUs"};